<template>
    <div class="right-container">
        <p class="right-h2">关于CSS</p>
        <p class="right-h3">reset.css</p>
        <p class="right-content">user agent stylesheet（用户代理样式表），简单来说就是浏览器的默认样式，但是每个浏览器的默认样式可能都是不一样的，所以需要重置浏览器的默认样式，即需要reset.css。</p>
        <img src="../../assets/img/img1.jpg">
        <p class="right-content">以下是我的reset.css，可以直接复制使用，如果项目里面有其他特殊情况可以自行修改。</p>
        <div class="right-code">
            <pre>
                <code class="language-css line-numbers" v-html="code.css.css1"></code>
            </pre>
        </div>
        <p class="right-h3">CSS命名</p>
        <p class="right-content">在给class属性命名时应使用小写，如果是多单词，应使用中横线进行连接，不应使用驼峰。（id属性同理）</p>
        <p class="right-content">示例如下：</p>
        <div class="right-code">
            <pre>
                <code class="language-css line-numbers" v-html="code.css.css2"></code>
            </pre>
        </div>
        <p class="right-h3">CSS使用</p>
        <p class="right-content">一般来说不太建议过多地使用id作为元素的样式索引，因为这可能会导致后期修改困难，但是可以在页面或者复用元素的根元素上使用id作为元素样式索引。</p>
        <p class="right-content">示例如下：</p>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.css.css3"></code>
            </pre>
        </div>
        <p class="right-content">在写CSS样式时，一般不建议嵌套太深，嵌套4层以下最好，超过4层会显得样式混乱并且修改困难，而想要CSS样式嵌套不深就需要在class属性命名上多下功夫。</p>
        <div class="right-code">
            <pre>
                <code class="language-css line-numbers" v-html="code.css.css4"></code>
            </pre>
        </div>
        <p class="right-h3">不要使用 @import</p>
        <p class="right-content">与 <code>&lt;link></code> 标签相比，<code>@import</code> 指令要慢很多，不光增加了额外的请求次数，还会导致不可预料的问题。替代办法有以下几种：</p>
        <ul>
            <li>使用多个 <code>&lt;link></code> 元素</li>
            <li>通过 <code>Sass</code> 或 <code>Less</code> 之类的 CSS 预处理器将多个 CSS 文件编译为一个文件</li>
        </ul>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.css.css5"></code>
            </pre>
        </div>
        <p class="right-h3">代码组织</p>
        <ul>
            <li>以组件为单位组织代码段。</li>
            <li>使用一致的空白符将代码分隔成块，这样利于扫描较大的文档。</li>
            <li>如果使用了多个 CSS 文件，将其按照组件而非页面的形式分拆，因为页面会被重组，而组件只会被移动。</li>
        </ul>
        <div class="right-code">
            <pre>
                <code class="language-css line-numbers" v-html="code.css.css6"></code>
            </pre>
        </div>
    </div>
</template>

<script>
import code from '../../utils/code'
import Prism from 'prismjs'
import 'prismjs/themes/prism.css'
export default {
    name: 'reset',
    data () {
        return {
            code: code
        }
    },
    mounted () {
        Prism.highlightAll()
    }
}
</script>

<style lang="scss" scoped>

</style>